import { get, post, put, patch, remove } from "./utils";

export const message = {
  listMessage: (parameters, token) => {
    return get("/api/message/messages/my_unread_receive/", parameters, token);
  },
  listLatestMessage: (parameters, token) => {
    return get("/api/message/messages/my_unread_receive/", parameters, token);
  },
  listMyBacklogMessage: (parameters, token) => {
    return get("/api/message/messages/my_backlog/", parameters, token);
  },
  listMyDraftMessage: (parameters, token) => {
    return get("/api/message/messages/my_draft/", parameters, token);
  },
  listMyReceiveMessage: (parameters, token) => {
    return get("/api/message/messages/my_receive/", parameters, token);
  },
  exportToCSV: (parameters, token) => {
    return get("/api/message/messages/export_to_csv/", parameters, token);
  },
  getMessage: (id, token) => {
    return get(`/api/message/messages/${id}/`, {}, token);
  },
  removeMessage: (id, token) => {
    return remove(`/api/message/messages/${id}/`, {}, token);
  },
  createMessage: (parameters, token) => {
    return post("/api/message/messages/", parameters, token);
  },
  updateMessage: (id, parameters, token) => {
    return put(`/api/message/messages/${id}/`, parameters, token);
  },
  partialUpdateMessage: (id, parameters, token) => {
    return patch(`/api/message/messages/${id}/`, parameters, token);
  },
  publishMessage: (id, token) => {
    return patch(`/api/message/messages/${id}/`, { status: 1 }, token);
  },
  backMessage: (id, parameters, token) => {
    return post(`/api/message/messages/${id}/back/`, parameters, token);
  },
  pushMessage: (id, parameters, token) => {
    return post(`/api/message/messages/${id}/push/`, parameters, token);
  },
  reportMessage: (id, parameters, token) => {
    return post(`/api/message/messages/${id}/report/`, parameters, token);
  },
  ignoreMessage: (id, parameters, token) => {
    return post(`/api/message/messages/${id}/ignore/`, parameters, token);
  },
  waitMessage: (id, parameters, token) => {
    return post(`/api/message/messages/${id}/wait/`, parameters, token);
  },
  readMessage: (id, parameters, token) => {
    return post(`/api/message/messages/${id}/read/`, parameters, token);
  },
};
